import {
  GET_ABOUT_US_REQUEST,
  UPDATE_ABOUT_US_REQUEST,
} from '../types/aboutUs'

export const getAboutUs = (payload = {}) => ({
  type: GET_ABOUT_US_REQUEST,
  payload,
})

export const updateAboutUs = (payload) => ({
  type: UPDATE_ABOUT_US_REQUEST,
  payload,
})

